import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesComponent } from './messages.component';
import { ConversationComponent } from './conversation/conversation.component';
import { MessagesRoutingModule } from './messages-routing.module';
import { FeatureModule } from '../../../../shared/src/lib/feature/feature.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../../shared/src/lib/material.module';
import { ContactsComponent } from './contacts/contacts.component';
import { ConversationService } from '../../../../shared/src/lib/service/conversation.service';
import { MomentModule } from 'ngx-moment';
import { TranslateModule } from '@ngx-translate/core';
import { ContactComponent } from './contacts/contact/contact.component';
import { DocumentsModule } from '../documents/documents.module';
import { DirectiveModule } from '../../../../shared/src/lib/directive/directive.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    FeatureModule,
    FormsModule,
    MomentModule,
    MessagesRoutingModule,
    DocumentsModule,
    DirectiveModule,
    TranslateModule.forChild(),
    CKEditorModule
  ],
  declarations: [MessagesComponent, ConversationComponent, ContactsComponent, ContactComponent],
  providers: [ConversationService]
})
export class MessagesModule { }
